import {
  Car,
  Gift,
  Heart,
  House,
  LayoutGrid,
  LayoutPanelLeft,
  Laptop,
  type LucideIcon,
  Settings,
  Smartphone,
  Snowflake,
  Trophy,
  Tv,
  Wrench,
} from "lucide-react";

/** Backend sends an icon key per top-level category (catalog.categories.icon). */
const ICONS: Record<string, LucideIcon> = {
  tv: Tv,
  smartphone: Smartphone,
  home: House,
  settings: Settings,
  laptop: Laptop,
  snowflake: Snowflake,
  layout: LayoutPanelLeft,
  trophy: Trophy,
  wrench: Wrench,
  heart: Heart,
  gift: Gift,
  car: Car,
};

export function categoryIcon(key: string | null | undefined): LucideIcon {
  return (key ? ICONS[key] : undefined) ?? LayoutGrid;
}
